import { createFileRoute } from "@tanstack/react-router"
import { AppDownload } from "@/components/AppDownload"

export const Route = createFileRoute("/download")({
  head: () => ({
    meta: [
      { title: "Download Wild Guess Trivia" },
      {
        name: "description",
        content: "Download Wild Guess Trivia for iPhone or Android.",
      },
    ],
  }),
  component: AppDownload,
})
